import React, { useState, useEffect } from 'react';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import Images from '../Images';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function Vacverification() {

    const [vacstep, setVacstep] = useState(1);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [vacstep]);
    return (
        <div>
            <div>
                <Header />
                <div className='inner_page position-relative pb-5'>
                    <img src={Images.a1logo} className='elogo' alt="elogo" />
                    <img src={Images.smallround} className='smallround_footer' alt='round'/>
                  
                    <Container className='mt-5'>
                        <div className='vac_border position-relative rounded-3 py-5 px-2 px-sm-4'>
                        <img src={Images.a1logo} className='a1logo' alt='round'/>
                        <img src={Images.a2logo} className='a2logo' alt="elogo" />
                        <img src={Images.a2logo} className='a3logo' alt="elogo" />
                            <Row>
                                <Col xl={vacstep === 1 ? 6 : 7} className='mx-auto position-relative'>
                                <img src={Images.smallround} className='bot_round' alt='round'/>
                                    <div className='vac_border rounded-4 py-4 px-4'>
                                        {vacstep === 1 &&
                                            <>
                                                <h4 className='text-center'>Begin Verification</h4>
                                                <p className='text-center'>Fields marked with an asterisk (*) are required.</p>
                                                <div className='mb-3'>
                                                    <label className='mb-2'>Please, type in Full Name of Asset (e.g. EDA coin):</label>
                                                    <input type='text' className='form-control verifi_input' />
                                                </div>
                                                <div>
                                                    <label className='mb-2'>Paste Contract Address:</label>
                                                    <input type='text' className='form-control verifi_input' />
                                                </div>
                                                <div className='text-center'><button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(2)}>Continue</button></div>
                                            </>
                                        }
                                        {vacstep === 2 &&
                                            <>
                                                <h4 className='text-center pb-3'>EdaFace Academy SOC Item 1: Coin Supply</h4>
                                             
                                               <div className='mt-3'>
                                               <p className='que'>Evaluative Question 1: Is the maximum coin supply known?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2 mb-0'>This question seeks to know the <b>fifth-level transparency</b> of the crypto project.</p>
                                                </div>

                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 2: Is the total coin supply known?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This question seeks to know if there are coins that have been burnt, hence, determining the <b>first level scarcity</b> of the crypto, which affects the market price.</p>
                                                </div>



                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 3: Is the circulating coin supply the same as the total supply?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This question seeks to identify any hidden centralization of the crypto that can be used to dump  the coin later in the market. By this, it seeks to establish the sixth-level transparency.</p>
                                                </div>
                                                <div className='text-end'>
                                                    <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(3)}>Next Page</button></div>


                                            </>}


                                            {vacstep === 3 &&
                                            <>
                                                <h4 className='text-center'>EdaFace Academy SOC Item 2: Use Case</h4>
                                                <p className='text-center mb-4'>Fields marked with an asterisk (*) are required.</p>
                                               <div className='mt-3'>
                                               <p className='que'>Evaluative Question 1: Does it solve any specific need of humanity?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2 mb-0'>This seeks to ascertain the <b>first-level relevance</b> of the crypto project.</p>
                                                </div>

                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 2: Are there two or more unique use cases of the crypto project?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish the <b>first-level uniqueness</b> as well as second-level durability of the  crypto project because the more functions it has the more unique and the longer the project will  last.</p>
                                                </div>



                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 3: Is there or will there be a DeFi application in the crypto project within  12 months?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish <b>third-level durability and second-level relevance</b> of the crypto project.</p>
                                                </div>
                                                <div className='d-flex justify-content-between gap-3'>
                                                <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(2)}>Previous Page</button>
                                                <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(4)}>Next Page</button>
                                                </div>
                                            </>}


                                            {vacstep === 4 &&
                                            <>
                                                <h4 className='text-center'>EdaFace Academy SOC Item 3: Market Value</h4>
                                                <p className='text-center mb-4'>Fields marked with an asterisk (*) are required.</p>
                                               <div className='mt-3'>
                                               <p className='que'>Evaluative Question 1: Is it listed in at least one of the top 5 high-volume exchanges?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2 mb-0'>This seeks to know the <b>fifth-level reliability</b> as well as the first-level viability of the crypto  project.</p>
                                                </div>

                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 2: Is Total Liquidity Supply up to 30% of Undiluted Market Capitalization?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish the trading liquidity, hence, the <b>second-level viability</b> of the crypto  project.</p>
                                                </div>



                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 3: Is the 24-hour trading volume upto one million USD?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish the trading liquidity, hence, the <b>third-level viability</b> of the crypto project.</p>
                                                </div>
                                                <div className='d-flex justify-content-between gap-3'>
                                                <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(3)}>Previous Page</button>
                                                    <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(5)}>Next Page</button>
                                                    </div>


                                            </>}



                                            {vacstep === 5 &&
                                            <>
                                                <h4 className='text-center'>EdaFace Academy SOC Item 4: Application Protocol</h4>
                                                <p className='text-center mb-4'>Fields marked with an asterisk (*) are required.</p>
                                               <div className='mt-3'>
                                               <p className='que'>Evaluative Question 1: Is the Whitepaper available and well-documented?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2 mb-0'>This seeks to ascertain the third-level transparency and second-level reliability of the crypto  project.</p>
                                                </div>

                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 2: Is it Open-Source code?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish fourth-level transparency and third-level reliability of the crypto  project.</p>
                                                </div>



                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 3: Is the Project audited by a reputable crypto auditor?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish fourth-level reliability and first-level durability of the crypto project.</p>
                                                </div>
                                                <div className='d-flex justify-content-between gap-3'>
                                                <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(4)}>Previous Page</button>
                                                    <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(6)}>Next Page</button>
                                                    </div>


                                            </>}



                                            {vacstep === 6 &&
                                            <>
                                                <h4 className='text-center'>EdaFace Academy SOC Item 5: Project Team</h4>
                                                <p className='text-center mb-4'>Fields marked with an asterisk (*) are required.</p>
                                               <div className='mt-3'>
                                               <p className='que'> Evaluative Question 1: Is the Project Team known?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2 mb-0'>This seeks to know the <b>first-level transparency</b> of the project.</p>
                                                </div>

                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 2: Is the Project Organization registered with a government regulatory  body?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish <b>first-level reliability.</b></p>
                                                </div>



                                                <div className='mt-4'>
                                               <p className='que'>Evaluative Question 3: Has ownership of the Project been renounced?</p>
                                               <div className='d-flex gap-4'>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       Yes
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                <div class="form-check">
                                                    <label class="form-check-label" for="flexCheckDefault">
                                                       No
                                                    </label>
                                                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                </div>
                                                </div>
                                                <p className='mt-2'>This seeks to establish the <b>second-level transparency</b> of the project.</p>
                                                </div>
                                                <div className='d-flex justify-content-between gap-3'>
                                                <button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4' onClick={() => setVacstep(5)}>Previous Page</button>
                                                   <Link to="/vac-scorecard"><button className='themebtn themehoverbtn  rounded-1 mt-4 py-2 px-4'>Next Page</button></Link> 
                                                    </div>


                                            </>}




                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </Container>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Vacverification